import React, { useState } from "react";
import TableCategory from "./TableCategory";

export const Category = () => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div className="container">
      <h1 className="title" style={{ marginBottom: 20 }}>
        Категории
      </h1>

      <TableCategory
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
      />
    </div>
  );
};
